var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("a", { staticClass: "event-card", attrs: { href: _vm.item.Url } }, [
      _c("div", { staticClass: "event-card__picture-wrap" }, [
        _c(
          "div",
          { staticClass: "event-card__date-block" },
          [
            [
              _c("div", { staticClass: "event-card__info-icon" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "26",
                      height: "24",
                      viewBox: _vm.FrequencyLabel.viewBox
                    }
                  },
                  [_c("use", { attrs: { href: _vm.FrequencyLabel.url } })]
                )
              ])
            ],
            _vm._v(" "),
            _vm.item.FrequencyLabel
              ? _c("p", { staticClass: "event-card__frequency" }, [
                  _vm._v(_vm._s(_vm.item.FrequencyLabel))
                ])
              : _vm.item.GroupEvent
              ? _c("p", { staticClass: "event-card__frequency" }, [
                  _vm._v(_vm._s(_vm.item.GroupEvent))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.item.EventDatesList[0]
              ? [
                  _vm.item.EventDatesList[0].Day
                    ? _c("p", { staticClass: "event-card__date" }, [
                        _vm._v(_vm._s(_vm.item.EventDatesList[0].Day))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.item.EventDatesList[0].Month
                    ? _c("p", { staticClass: "event-card__month" }, [
                        _vm._v(_vm._s(_vm.item.EventDatesList[0].Month))
                      ])
                    : _vm._e()
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _vm.item.Image
          ? _c(
              "picture",
              {
                staticClass:
                  "event-card__image c-image-frame c-image-frame--border-radius-at-medium"
              },
              [
                _c("img", {
                  staticClass: "c-image-frame__image lazyload",
                  attrs: {
                    width: "1200",
                    height: "750",
                    "data-sizes": "auto",
                    alt: "",
                    "data-srcset":
                      _vm.item.Image.Crops["16:10 Aspect Ratio Crop"].SrcSet,
                    "data-src":
                      _vm.item.Image.Crops["16:10 Aspect Ratio Crop"].Src
                  }
                })
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "event-card__summary" }, [
        _c(
          "div",
          { staticClass: "event-card__info" },
          [
            _vm.item.InPersonOnline !== ""
              ? [
                  _vm.InPersonOnline !== null
                    ? _c("div", { staticClass: "event-card__info-icon" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: _vm.InPersonOnline.width,
                              height: _vm.InPersonOnline.height,
                              viewBox: _vm.InPersonOnline.viewBox
                            }
                          },
                          [
                            _c("use", {
                              attrs: { href: _vm.InPersonOnline.url }
                            })
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "event-card__info-item" }, [
                    _vm._v(_vm._s(_vm.item.InPersonOnline))
                  ])
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.item.GroupEvent !== ""
              ? [
                  _vm.groupOrEventIcon !== null
                    ? _c("div", { staticClass: "event-card__info-icon" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "19",
                              height: "23",
                              viewBox: _vm.groupOrEventIcon.viewBox
                            }
                          },
                          [
                            _c("use", {
                              attrs: { href: _vm.groupOrEventIcon.url }
                            })
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "event-card__info-item" }, [
                    _vm._v(_vm._s(_vm.item.GroupEvent))
                  ])
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _c("h2", { staticClass: "event-card__heading" }, [
          _vm._v("\n        " + _vm._s(_vm.item.Name) + "\n      ")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "event-card__address" }, [
          _vm._v(_vm._s(_vm.item.Address))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "event-card__time" }, [
          _vm._v(_vm._s(_vm.item.Time))
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "mini-tag-list" },
          [
            _vm.item.Tags
              ? [
                  _vm._l(_vm.item.Tags.slice(0, 2), function(tag) {
                    return _c(
                      "li",
                      { key: tag, staticClass: "mini-tag-list__item" },
                      [_vm._v(_vm._s(tag.Name))]
                    )
                  }),
                  _vm._v(" "),
                  _vm.item.Tags.length > 2
                    ? _c("li", { staticClass: "mini-tag-list__item" }, [
                        _vm._v("...")
                      ])
                    : _vm._e()
                ]
              : _vm.item.PrimaryTag
              ? _c("li", { staticClass: "mini-tag-list__item" }, [
                  _vm._v(_vm._s(_vm.item.PrimaryTag.Name))
                ])
              : _vm._e()
          ],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }